export const FETCH_MY_ROARS = 'FETCH_MY_ROARS';
export const FETCH_MY_ROARS_SUCCESS = 'FETCH_MY_ROARS_SUCCESS';
export const FETCH_MY_ROARS_FAILURE = 'FETCH_MY_ROARS_FAILURE';



// WEBPACK FOOTER //
// ./src/routes/Profile/components/MyRoars/modules/constants.js